import Layouts from '@/components/layouts/LayoutsView.vue'
import ActivityList from '@/views/grabAndShootActivity/ActivityList.vue'
import PrizesList from '@/views/grabAndShootActivity/PrizesList.vue'
import PrizeDistributed from '@/views/grabAndShootActivity/PrizeDistributed.vue'
import DataList from '@/views/grabAndShootActivity/DataList.vue'

export default [
  {
    path: '/grabAndShoot',
    name: '抢拍活动',
    component: Layouts,
    meta: {
      title: '抢拍活动'
    },
    children: [
      {
        path: 'activityList',
        name: '活动列表 ',
        meta: {
          title: '活动列表'
        },
        component: ActivityList
      },
      {
        path: 'prizesList',
        name: '奖品列表 ',
        meta: {
          title: '奖品列表'
        },
        hidden: true,
        component: PrizesList
      },
      {
        path: 'dataList',
        name: '数据列表 ',
        meta: {
          title: '数据列表'
        },
        hidden: true,
        component: DataList
      },
      {
        path: 'prizeDistributed',
        name: '奖品发放 ',
        meta: {
          title: '奖品发放'
        },
        component: PrizeDistributed
      }
    ]
  }
]
